// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-company-indexstyleGrid-container-sikwh{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-company-indexstyleGrid-grid-bwlub{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-company-indexstyleGrid-col6-bluez{grid-column:span 6}.pages-company-indexstyleGrid-col3-rbidd{grid-column:span 3}.pages-company-indexstyleGrid-col4-cawdz{grid-column:span 4}.pages-company-indexstyleGrid-col9-bpmuk{grid-column:span 9}.pages-company-indexstyleGrid-col12-bxhov{grid-column:span 12}.pages-company-indexstyleGrid-alignItemsStart-knlhx{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-company-indexstyleGrid-container-sikwh",
	"grid": "pages-company-indexstyleGrid-grid-bwlub",
	"col6": "pages-company-indexstyleGrid-col6-bluez",
	"col3": "pages-company-indexstyleGrid-col3-rbidd",
	"col4": "pages-company-indexstyleGrid-col4-cawdz",
	"col9": "pages-company-indexstyleGrid-col9-bpmuk",
	"col12": "pages-company-indexstyleGrid-col12-bxhov",
	"alignItemsStart": "pages-company-indexstyleGrid-alignItemsStart-knlhx"
};
module.exports = ___CSS_LOADER_EXPORT___;
